/* unplugin-vue-components disabled */import { render } from "./SemesterCapacity.vue?vue&type=template&id=b7b99dfc&scoped=true"
import script from "./SemesterCapacity.vue?vue&type=script&lang=js"
export * from "./SemesterCapacity.vue?vue&type=script&lang=js"

import "./SemesterCapacity.vue?vue&type=style&index=0&id=b7b99dfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b99dfc"]])

export default __exports__